<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="楼层名称">
                  <el-input  v-model="queryForm.floorName"></el-input>
              </el-form-item>
              <el-form-item label="楼层颜色">
                  <el-input  v-model="queryForm.floorColor"></el-input>
              </el-form-item>
              <el-form-item label="层楼左边广告">
                  <el-input  v-model="queryForm.floorAdsLeft"></el-input>
              </el-form-item>
              <el-form-item label="层楼左边广告链接">
                  <el-input  v-model="queryForm.floorAdsLeftLink"></el-input>
              </el-form-item>
              <el-form-item label="层楼右上方广告">
                  <el-input  v-model="queryForm.floorAdsRightUp"></el-input>
              </el-form-item>
              <el-form-item label="层楼右上方广告链接">
                  <el-input  v-model="queryForm.floorAdsRightUpLink"></el-input>
              </el-form-item>
              <el-form-item label="层楼右下方广告">
                  <el-input  v-model="queryForm.floorAdsRightDown"></el-input>
              </el-form-item>
              <el-form-item label="层楼右下方广告链接">
                  <el-input  v-model="queryForm.floorAdsRightDownLink"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getShopFloorList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopFloor"
        >添加楼层</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addShopFloorActivity"
        >添加活动</el-button>
<!--        <el-button-->
<!--          type="danger"-->
<!--          plain-->
<!--          size="small"-->
<!--          icon="el-icon-delete"-->
<!--          :disabled="multipleSelection.length <= 0"-->
<!--          @click="deleteShopFloor(null)"-->
<!--        >删除</el-button>-->
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          title="下载模板"
          class="icon-box"
          @click="importTemplate"
        >
          <Icon color="#606266">
            <ArrowDown />
          </Icon>
        </span>
        <span
          class="icon-box"
          title="导入数据"
          @click="isImport"
        >
          <Icon color="#606266">
            <ArrowExportUp24Regular />
          </Icon>
        </span>
        <span
          title="导出数据"
          class="icon-box"
          @click="exportShopFloorList"
        >
          <Icon color="#606266">
            <ArrowDownload24Regular />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshShopFloorList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="shopFloorList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      :tree-props="{ children: 'activityList', hasChildren: 'hasChildren' }"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        prop="floorName"
        label="楼层名称"
        width="180"
      >
      <template slot-scope="scope">
          <span v-if="scope.row.activityName">{{scope.row.activityName}}</span>
          <span v-if="scope.row.floorName">{{scope.row.floorName}}</span>
      </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="floorColor"
        label="楼层颜色"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="floorAdsLeft"
        label="层楼左边广告"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if='scope.row.floorAdsLeft' style="display: flex;justify-content: center;align-items: center;">
                  <el-image @click='updateSrcList(scope.row.floorAdsLeft)' style="width: 60px; height: 60px"
                            :src="scope.row.floorAdsLeft" :preview-src-list="srcList"> </el-image>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="floorAdsLeftLink"
        label="层楼左边广告链接"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="floorAdsRightUp"
        label="层楼右上方广告"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if='scope.row.floorAdsRightUp' style="display: flex;justify-content: center;align-items: center;">
                  <el-image @click='updateSrcList(scope.row.floorAdsRightUp)' style="width: 60px; height: 60px"
                            :src="scope.row.floorAdsRightUp" :preview-src-list="srcList"> </el-image>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="floorAdsRightUpLink"
        label="层楼右上方广告链接"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="floorAdsRightDown"
        label="层楼右下方广告"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if='scope.row.floorAdsRightDown' style="display: flex;justify-content: center;align-items: center;">
                  <el-image @click='updateSrcList(scope.row.floorAdsRightDown)' style="width: 60px; height: 60px"
                            :src="scope.row.floorAdsRightDown" :preview-src-list="srcList"> </el-image>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="floorAdsRightDownLink"
        label="层楼右下方广告链接"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="320"
      >
        <template slot-scope="scop">
          <div v-if="scop.row.floorName" class="operation">
              <div @click="categoryShow(scop.row.id)">
                  <span class="operation-label">管理分类</span>
              </div>
              <div @click="brandShow(scop.row.id)">
                  <span class="operation-label">管理品牌</span>
              </div>
            <div @click="checkShopFloor(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editShopFloor(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteShopFloor(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
            <div class="operation" v-else>
                <div @click="productShow(scop.row.id)">
                    <span class="operation-label">管理商品</span>
                </div>
                <div @click="checkShopFloorActivity(scop.row.id)">
                    <Icon size="16">
                        <Eye24Regular />
                    </Icon>
                    <span class="operation-label">查看</span>
                </div>
                <div @click="editShopFloorActivity(scop.row.id)">
                    <Icon size="16">
                        <Edit24Regular />
                    </Icon>
                    <span class="operation-label">修改</span>
                </div>
                <div @click="deleteShopFloorActivity(scop.row.id)">
                    <Icon size="16" style="color: red">
                        <Delete24Regular />
                    </Icon>
                    <span class="operation-label" style="color: red">删除</span>
                </div>
            </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="shopFloorStates[shopFloorState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="shopFloor"
          ref="shopFloorForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="楼层名称"
            prop="floorName"
          >
            <el-input
              size="small"
              style="width: 180px"
              v-model="shopFloor.floorName"
              :disabled="shopFloorState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="楼层颜色"
            prop="floorColor"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopFloor.floorColor"-->
<!--              :disabled="shopFloorState == 'check'"-->
<!--            ></el-input>-->
              <div style="flex: 1;display: flex;align-items: center;width: 180px">
                  <el-input v-model="shopFloor.floorColor" :disabled="shopFloorState == 'check'" size="small"></el-input>
                  <el-color-picker v-model="shopFloor.floorColor" :disabled="shopFloorState == 'check'" size="medium" style="margin-left: 2px;"></el-color-picker>
              </div>
          </el-form-item>
          <el-form-item
            label="层楼左边广告"
            prop="floorAdsLeft"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopFloor.floorAdsLeft"-->
<!--              :disabled="shopFloorState == 'check'"-->
<!--            ></el-input>-->
              <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                         :disabled="shopFloorState == 'check'" class="avatar-uploader" :show-file-list="false"
                         :http-request="uploadImage">
                  <img v-if="shopFloor.floorAdsLeft" :src="shopFloor.floorAdsLeft" class="avatar" size="small" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
          </el-form-item>
          <el-form-item
            label="层楼左边广告链接"
            prop="floorAdsLeftLink"
          >
            <el-input
              size="small"
              v-model="shopFloor.floorAdsLeftLink"
              :disabled="shopFloorState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="层楼右上方广告"
            prop="floorAdsRightUp"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopFloor.floorAdsRightUp"-->
<!--              :disabled="shopFloorState == 'check'"-->
<!--            ></el-input>-->
              <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                         :disabled="shopFloorState == 'check'" class="avatar-uploader" :show-file-list="false"
                         :http-request="uploadImage1">
                  <img v-if="shopFloor.floorAdsRightUp" :src="shopFloor.floorAdsRightUp" class="avatar" size="small" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
          </el-form-item>
          <el-form-item
            label="层楼右上方广告链接"
            prop="floorAdsRightUpLink"
          >
            <el-input
              size="small"
              v-model="shopFloor.floorAdsRightUpLink"
              :disabled="shopFloorState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="层楼右下方广告"
            prop="floorAdsRightDown"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="shopFloor.floorAdsRightDown"-->
<!--              :disabled="shopFloorState == 'check'"-->
<!--            ></el-input>-->
              <el-upload :action="action" :headers="header" :before-upload="beforeImageUpload"
                         :disabled="shopFloorState == 'check'" class="avatar-uploader" :show-file-list="false"
                         :http-request="uploadImage2">
                  <img v-if="shopFloor.floorAdsRightDown" :src="shopFloor.floorAdsRightDown" class="avatar" size="small" />
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
          </el-form-item>
          <el-form-item
            label="层楼右下方广告链接"
            prop="floorAdsRightDownLink"
          >
            <el-input
              size="small"
              v-model="shopFloor.floorAdsRightDownLink"
              :disabled="shopFloorState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="shopFloorState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
<!--   楼层活动   -->
      <!-- 新增/查看/修改信息 -->
      <el-dialog
          :title="shopFloorActivityStates[shopFloorActivityState]"
          :visible.sync="showDialogFloorActivity"
          width="60%"
          @close="closeDialogFloorActivity"
      >
          <div>
              <el-form
                  :model="shopFloorActivity"
                  ref="shopFloorActivityForm"
                  :rules="rulesFloorActivity"
                  label-width="120px"
                  :inline="true"
                  size="small"
              >
                  <el-form-item
                      label="活动名称"
                      prop="activityName"
                  >
                      <el-input
                          size="small"
                          v-model="shopFloorActivity.activityName"
                          :disabled="shopFloorActivityState == 'check'"
                      ></el-input>
                  </el-form-item>
                  <el-form-item
                      label="所属楼层"
                      prop="floorId"
                  >
<!--                      <el-input-->
<!--                          size="small"-->
<!--                          v-model="shopFloorActivity.floorId"-->
<!--                          :disabled="shopFloorActivityState == 'check'"-->
<!--                      ></el-input>-->
                      <el-select
                          style="width: 180px"
                          v-model="shopFloorActivity.floorId"
                          placeholder="请选择所属楼层"
                          :disabled="shopFloorActivityState == 'check'"
                          clearable
                          size="small"
                      >
                          <el-option v-for="(item,index) in shopFloorList " :label="item.floorName" :value="item.id" :key="index"> </el-option>
                      </el-select>
                  </el-form-item>
                  <el-form-item
                      label="排序"
                      prop="sort"
                  >
                      <el-input
                          size="small"
                          v-model="shopFloorActivity.sort"
                          :disabled="shopFloorActivityState == 'check'"
                      ></el-input>
                  </el-form-item>
              </el-form>
          </div>

          <div
              slot="footer"
              class="flex justify-end"
          >
              <el-button @click="closeDialogFloorActivity">关闭</el-button>
              <el-button
                  type="primary"
                  @click="submitFormFloorActivity"
                  v-if="shopFloorActivityState != 'check'"
              >确定</el-button>
          </div>
      </el-dialog>

      <el-drawer
          title="分类管理"
          :visible.sync="categoryStatus"
          direction="rtl"
          size="70%"
          :before-close="categoryClose">
          <ShopFloorCategory ref="ShopFloorCategory"></ShopFloorCategory>
      </el-drawer>
      <el-drawer
          title="品牌管理"
          :visible.sync="brandStatus"
          direction="rtl"
          size="70%"
          :before-close="brandClose">
          <ShopFloorBrand ref="ShopFloorBrand"></ShopFloorBrand>
      </el-drawer>
      <el-drawer
          title="商品管理"
          :visible.sync="productStatus"
          direction="rtl"
          size="70%"
          :before-close="productClose">
          <ShopFloorActivityProduct ref="ShopFloorActivityProduct"></ShopFloorActivityProduct>
      </el-drawer>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun, upload } from '@/utils/request.js';
import ShopFloorCategory from '@/components/shop/ShopFloorCategory.vue';
import ShopFloorBrand from '@/components/shop/ShopFloorBrand.vue';
import ShopFloorActivityProduct from '@/components/shop/ShopFloorActivityProduct.vue';
import { UPLOAD_PATH, UPLOAD_API, USER, PRODUCT, PRODUCT_SEARCH, USER_SEARCH, PROMOTER, PROMOTER_SEARCH, PERSON, PERSON_SEARCH } from '@/utils/constant.js';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        ShopFloorCategory,
        ShopFloorBrand,
        ShopFloorActivityProduct
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetShopFloorList();
                    this.getShopFloorList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetShopFloorList();
                    this.getShopFloorList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     floorName: '', //楼层名称
                     floorColor: '', //楼层颜色
                     floorAdsLeft: '', //层楼左边广告
                     floorAdsLeftLink: '', //层楼左边广告链接
                     floorAdsRightUp: '', //层楼右上方广告
                     floorAdsRightUpLink: '', //层楼右上方广告链接
                     floorAdsRightDown: '', //层楼右下方广告
                     floorAdsRightDownLink: '', //层楼右下方广告链接
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                shopFloorState: 'add',
                shopFloorStates: {
                    add: '新建shop_floor',
                    check: '查看shop_floor',
                    edit: '修改shop_floor'
                },
                shopFloorActivityStates: {
                    add: '新建shop_floor_activity',
                    check: '查看shop_floor_activity',
                    edit: '修改shop_floor_activity'
                },
                multipleSelection: [],
                shopFloorList: [],
                shopFloor: {
                    id: '', //ID
                    floorName: '', //楼层名称
                    floorColor: '', //楼层颜色
                    floorAdsLeft: '', //层楼左边广告
                    floorAdsLeftLink: '', //层楼左边广告链接
                    floorAdsRightUp: '', //层楼右上方广告
                    floorAdsRightUpLink: '', //层楼右上方广告链接
                    floorAdsRightDown: '', //层楼右下方广告
                    floorAdsRightDownLink: '', //层楼右下方广告链接
                },
                btnLoading: false,

                rules: {
                    floorName: [{ required: true, message: '楼层名称不能为空', trigger: 'blur' }],
                    floorColor: [{ required: true, message: '楼层颜色不能为空', trigger: 'blur' }],
                    floorAdsLeft: [{ required: true, message: '层楼左边广告不能为空', trigger: 'blur' }],
                    floorAdsLeftLink: [{ required: true, message: '层楼左边广告链接不能为空', trigger: 'blur' }],
                    floorAdsRightUp: [{ required: true, message: '层楼右上方广告不能为空', trigger: 'blur' }],
                    floorAdsRightUpLink: [{ required: true, message: '层楼右上方广告链接不能为空', trigger: 'blur' }],
                    floorAdsRightDown: [{ required: true, message: '层楼右下方广告不能为空', trigger: 'blur' }],
                    floorAdsRightDownLink: [{ required: true, message: '层楼右下方广告链接不能为空', trigger: 'blur' }],
                },



                shopFloorActivity: {
                    id: '',
                    activityName: '', //活动名称
                    floorId: '',
                    sort: 10
                },
                currentShopFloorActivityId:'',
                showDialogFloorActivity: false,
                shopFloorActivityState:'add',
                rulesFloorActivity: {
                    activityName: [{ required: true, message: '活动名称不能为空', trigger: 'blur' }],
                    floorId: [{ required: true, message: '所属楼层不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                },

                categoryStatus: false,
                brandStatus: false,
                productStatus: false,


                header: {
                    token: localStorage.getItem('token')
                },
                action: UPLOAD_API + UPLOAD_PATH,
                srcList: [''],
            };
        },
        created() {
            this.getShopFloorList();
                // this.loading = true;

        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetShopFloorList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.shopFloorList = [];
            },
            updateSrcList(url){
                this.srcList[0] = url
            },
            resetDialog() {
                this.shopFloorState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      floorName: '', //楼层名称
                      floorColor: '', //楼层颜色
                      floorAdsLeft: '', //层楼左边广告
                      floorAdsLeftLink: '', //层楼左边广告链接
                      floorAdsRightUp: '', //层楼右上方广告
                      floorAdsRightUpLink: '', //层楼右上方广告链接
                      floorAdsRightDown: '', //层楼右下方广告
                      floorAdsRightDownLink: '', //层楼右下方广告链接
                };
                this.getShopFloorList();
            },
            closeDialog() {
                this.showDialog = false
                this.shopFloor = {
                      id: '', //ID
                      floorName: '', //楼层名称
                      floorColor: '', //楼层颜色
                      floorAdsLeft: '', //层楼左边广告
                      floorAdsLeftLink: '', //层楼左边广告链接
                      floorAdsRightUp: '', //层楼右上方广告
                      floorAdsRightUpLink: '', //层楼右上方广告链接
                      floorAdsRightDown: '', //层楼右下方广告
                      floorAdsRightDownLink: '', //层楼右下方广告链接
                };
            },
            submitForm() {
                if (this.shopFloorState == 'add') {
                    this.$refs.shopFloorForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/floor/add`,{ ...this.shopFloor }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopFloorList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopFloorState == 'edit') {
                    this.$refs.shopFloorForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.shopFloor.activityList
                            delete this.shopFloor.categoryList
                            delete this.shopFloor.brandList
                            post(`/shop/floor/edit`,{ ...this.shopFloor }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopFloorList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopFloor() {
                this.showDialog = true;
                this.shopFloorState = 'add';
            },
            checkShopFloor(shopFloorId) {
                console.log(shopFloorId);
                this.currentShopFloorId = shopFloorId;

                this.getShopFloorById();
                this.showDialog = true;
                this.shopFloorState = 'check';
            },
            editShopFloor(shopFloorId) {
                console.log('shopFloor', shopFloorId);
                if (shopFloorId) {
                    this.currentShopFloorId = shopFloorId;
                    this.getShopFloorById();
                } else {
                    this.shopFloor = { ...this.shopFloor, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.shopFloorState = 'edit';
            },
            deleteShopFloor(shopFloorId) {
                let ids = '';
                if (shopFloorId) {
                    ids = shopFloorId;
                } else {
                    ids = this.multipleSelection.map((shopFloor) => shopFloor.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/floor/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopFloorList();
                                this.getShopFloorList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },


            submitFormFloorActivity() {
                if (this.shopFloorActivityState == 'add') {
                    this.$refs.shopFloorActivityForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/shop/flooractivity/add`,{ ...this.shopFloorActivity }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetShopFloorList();
                                    this.closeDialogFloorActivity();
                                    this.getShopFloorList();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.shopFloorActivityState == 'edit') {
                    this.$refs.shopFloorActivityForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.shopFloorActivity.productList
                            post(`/shop/flooractivity/edit`,{ ...this.shopFloorActivity }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetShopFloorList();
                                    this.closeDialogFloorActivity();
                                    this.getShopFloorList();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addShopFloorActivity() {
                this.showDialogFloorActivity = true;
                this.shopFloorActivityState = 'add';
            },
            checkShopFloorActivity(shopFloorActivityId) {
                console.log(shopFloorActivityId);
                this.currentShopFloorActivityId = shopFloorActivityId;

                this.getShopFloorActivityById();
                this.showDialogFloorActivity = true;
                this.shopFloorActivityState = 'check';
            },
            getShopFloorActivityById() {
                get(`/shop/flooractivity/get`,{ id: this.currentShopFloorActivityId }).then((res) =>{
                    if(res.success){
                        this.shopFloorActivity = { ...this.shopFloorActivity, ...res.shopFloorActivity };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            editShopFloorActivity(shopFloorActivityId) {
                console.log('shopFloorActivity', shopFloorActivityId);
                if (shopFloorActivityId) {
                    this.currentShopFloorActivityId = shopFloorActivityId;
                    this.getShopFloorActivityById();
                } else {
                    this.shopFloorActivity = { ...this.shopFloorActivity, ...this.multipleSelection[0] };
                }

                this.showDialogFloorActivity = true;
                this.shopFloorActivityState = 'edit';
            },
            deleteShopFloorActivity(shopFloorActivityId) {
                let ids = '';
                if (shopFloorActivityId) {
                    ids = shopFloorActivityId;
                } else {
                    ids = this.multipleSelection.map((shopFloorActivity) => shopFloorActivity.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/shop/flooractivity/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetShopFloorList();
                                this.getShopFloorList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            closeDialogFloorActivity() {
                this.showDialogFloorActivity = false
                this.shopFloorActivity = {
                    id: '', //ID
                    activityName: '', //活动名称
                    floorId: '',
                    sort: 10,
                };
            },




            //上传缩略图
            uploadImage(params) {
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
                if (!types.includes(file.type)) {
                    this.$message.error('图片类型错误!');
                }
                const formData = new FormData();
                formData.append('file', file);
                upload(UPLOAD_PATH, formData).then((res) => {
                    if (res.success) {
                        this.shopFloor.floorAdsLeft = res.url;
                    }
                });
            },
            beforeImageUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 50;
                if (!isLt2M) {
                    this.$message.error('上传图片大小不能超过 50MB!');
                }
                return isLt2M;
            },
            //上传缩略图
            uploadImage1(params) {
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
                if (!types.includes(file.type)) {
                    this.$message.error('图片类型错误!');
                }
                const formData = new FormData();
                formData.append('file', file);
                upload(UPLOAD_PATH, formData).then((res) => {
                    if (res.success) {
                        this.shopFloor.floorAdsRightUp = res.url;
                    }
                });
            },
            //上传缩略图
            uploadImage2(params) {
                const file = params.file;
                let types = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif'];
                if (!types.includes(file.type)) {
                    this.$message.error('图片类型错误!');
                }
                const formData = new FormData();
                formData.append('file', file);
                upload(UPLOAD_PATH, formData).then((res) => {
                    if (res.success) {
                        this.shopFloor.floorAdsRightDown = res.url;
                    }
                });
            },




            categoryShow(id){
                this.categoryStatus = true
                this.$nextTick(()=>{
                    this.$refs.ShopFloorCategory.updateId(id);
                })
            },
            categoryClose(){
                this.categoryStatus = false
            },
            brandShow(id){
                this.brandStatus = true
                this.$nextTick(()=>{
                    this.$refs.ShopFloorBrand.updateIds(id)
                })
            },
            brandClose(){
                this.brandStatus = false
            },
            productShow(id){
                this.productStatus = true
                this.$nextTick(()=>{
                    this.$refs.ShopFloorActivityProduct.updateId(id)
                })
            },
            productClose(){
                this.productStatus = false
            },


            refreshShopFloorList() {
                this.resetShopFloorList();
                this.getShopFloorList();
            },
            getShopFloorList(query = {}) {
                this.loading = true;
                get(`/shop/floor/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.shopFloorList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getShopFloorById() {
                get(`/shop/floor/get`,{ id: this.currentShopFloorId }).then((res) =>{
                    if(res.success){
                      this.shopFloor = { ...this.shopFloor, ...res.shopFloor };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportShopFloorList() {
                //this.btnLoading = true;
                exprotExcel(`/shop/floor/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/shop/floor/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/shop/floor/importData`,formData);
              this.refreshShopFloorList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getShopFloorList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getShopFloorList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.avatar {
    width: 180px;
    height: 180px;
    display: block;
}

::v-deep .el-upload--text {
    width: 180px;
    height: 180px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

::v-deep .el-range-separator{
    width: 20px;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 180px;
    height: 180px;
    line-height: 180px;
    text-align: center;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>